// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3462":"31dd9c5033db3f0d","4685":"b3740e4f6be9fc16"}[chunkId] + ".js";
};